import { GET_CASE_DETAILS_SUCCESS } from '@actions/caseDetails';

const defaultState = {
  data: {
    caseNumber: '',
    claimAgent: {
      address: {},
    },
    counselForDebtor: {
      address: {},
    },
    court: {
      address: {},
    },
    filingDate: '',
    name: '',
    usTrustee: {
      address: {},
    },
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_CASE_DETAILS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/caseDetails.js